import NewsBlockTitle from '@/ui/listItem/newsBlockTitle/NewsBlockTitle';
import NewsCardText from '../text/NewsCardText';

interface VerticalNewsFrameProps {
  title?: string;
  articles?: any[];
}

const VerticalNewsFrame = ({ title, articles = [] }: VerticalNewsFrameProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-6">
        <NewsBlockTitle title={title} />
        <img src={articles[0]?.image_} alt="img" className="w-full h-40 object-cover" />
      </div>
      <div>
        {articles.map((article, i) => (
          <NewsCardText key={i} article={article} />
        ))}
      </div>
    </div>
  );
};

export default VerticalNewsFrame;
